<template>
  <div>
    <v-container tag="section">
      <v-row>
        <v-col
          v-for="(card, index) in arrayComDataModificada"
          :key="index"
          class="pa-0"
          cols="12"
        >
          <v-flex
            v-if="card.created_at"
            :class="$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'body-1'"
            class="grey--text text--darken-1 pt-0 pb-1"
            data-cy="data_compra"
            tag="div"
          >
            Compra(s) em {{ card.created_at }}
          </v-flex>

          <v-card
            class="mt-1 mb-6 mb-lg-8 px-4 px-lg-7 py-6"
            min-height="180"
            :style="`border-left: 5px solid var(--v-${corStatus(card)}-base)`"
          >
            <div class="d-flex flex-nowrap">
              <div class="coluna-1 d-flex align-start pt-1">
                <v-card>
                  <v-img
                    v-if="card.image_url"
                    :alt="`Imagem do produto ${ card.product_name }`"
                    :src="card.image_url"
                    data-cy="card_imagem_produto"
                    height="120"
                    width="115"
                  />
                </v-card>

                <v-card-text
                  class="pb-0 pl-5 pl-lg-7 pr-3 pr-lg-4 col-info-produto"
                  data-cy="card_compra"
                  :class="card.is_instalment_recovery ? 'pt-0 mt-n1' : 'pt-8'"
                >
                  <div
                    v-if="statusCard(card) === 'Inadimplente'"
                    class="d-flex align-start"
                    style="margin-top: -8px; margin-bottom: 8px;"
                  >
                    <v-btn
                      color="success"
                      class="font-weight-bold"
                      :loading="loadingPagarReativar[card.id]"
                      :disabled="loadingPagarReativar[card.id]"
                      @click.stop="pagarEReativar(card)"
                    >
                      Pagar e Reativar
                    </v-btn>
                  </div>
                  <p
                    class="primary--text font-weight-bold pa-0 mb-0 d-block"
                    data-cy="card_nome_produto"
                  >
                    <span class="ellipsis nome-produto">{{ card.product_name }}</span>
                    -
                    <span class="ellipsis nome-plano">{{ card.plan_name }}</span>
                  </p>
                  <p
                    class="pl-0 my-3 d-flex align-center"
                  >
                    <span v-if="card.is_instalment_recovery && card.freight_cost">
                      <IconePagamento :dados="card" />
                      Primeira parcela: <strong>
                        {{ valorParcelaRecuperacao(card) | moeda(card.currency_symbol) }}
                      </strong>
                      + <strong>
                        {{ card.freight_cost | moeda(card.currency_symbol) }}
                      </strong> (frete)<br>

                      <IconePagamento :dados="card" />
                      Parcelas seguintes: <strong>
                        {{ card.max_recurrence_instalments - 1 }}x</strong>
                      de <strong>
                        {{ valorParcelaRecuperacao(card) | moeda(card.currency_symbol) }}
                      </strong>
                    </span>

                    <span v-else-if="card.order_bump_assinatura_show_message">
                      <IconePagamento :dados="card" />
                      -
                    </span>

                    <span v-else>
                      <IconePagamento :dados="card" />

                      {{ card.total | moeda(card.currency_symbol) }}

                      <span
                        v-if="card.is_instalment_recovery"
                        class="pl-1 grey--text"
                      >
                        ({{ card.paid_recurrence_instalments }}
                        de {{ card.max_recurrence_instalments }} parcelas)
                      </span>
                    </span>
                  </p>
                  <p
                    :class="corStatus(card, true)"
                    class="mb-0 d-flex align-center"
                    data-cy="status_compra"
                  >
                    <v-icon
                      :color="corStatus(card)"
                      class="pr-1"
                    >
                      {{ iconeStatus(card) }}
                    </v-icon>
                    {{ statusCard(card) }}
                  </p>
                  <v-chip
                    v-if="card.is_instalment_recovery"
                    class="mt-3 font-weight-bold"
                    color="primary"
                    small
                  >
                    Compra parcelada
                  </v-chip>
                </v-card-text>
              </div>

              <div
                v-if="card.seller"
                class="coluna-2 d-flex flex-column justify-end pr-3 body-2 align-baseline"
              >
                <p
                  class="mb-0 grey--text text--darken-2"
                  data-cy="label_texto_duvidas_atraves_dos_canais_de_atendimento"
                >
                  Falar com o vendedor {{ card.seller.name }}.
                </p>

                <a
                  v-if="card.seller.email"
                  :href="`mailto:${ card.seller.email }`"
                  class="mt-3 d-flex text-decoration-none"
                  data-cy="email_vendedor"
                  target="_top"
                >
                  <v-icon
                    class="mr-2"
                    color="primary"
                  >
                    mdi-email
                  </v-icon>
                  <span class="text-decoration-underline break-word">
                    {{ card.seller.email }}
                  </span>
                </a>

                <a
                  v-if="card.seller.phone"
                  :href="card.seller.phone | linkTelefone"
                  class="text-decoration-none mt-3"
                  data-cy="telefone_vendedor"
                  target="_blank"
                >
                  <v-icon
                    class="mr-1"
                    color="primary"
                  >
                    mdi-phone
                  </v-icon>
                  {{ card.seller.phone }}
                </a>

                <a
                  v-if="card.seller.whatsapp"
                  :href="card.seller.whatsapp | linkWhatsappDesktop"
                  class="text-decoration-none mt-3"
                  data-cy="whatsapp_vendedor"
                  target="_blank"
                >
                  <v-icon
                    color="secondary"
                    class="mr-1"
                  >
                    mdi-whatsapp
                  </v-icon>
                  {{ card.seller.whatsapp }}
                </a>

                <BtnEnviarMensagem
                  v-if="card.chat_enabled"
                  :id-transacao="card.id"
                  btn-small
                  class="mt-5"
                />
                <v-badge
                  v-if="card.notificacao_mensagem"
                  avatar
                  bordered
                  color="red"
                  offset-x="10"
                  offset-y="-10"
                />
              </div>

              <div class="coluna-3 pr-7 pr-lg-8 body-2 d-flex align-end">
                <InfoProduto
                  :dados="card"
                />
              </div>
            </div>

            <v-btn
              :to="{ name: 'detalhe-compra', params: { compraId: card.id }}"
              absolute
              bottom
              class="mr-lg-1"
              color="primary"
              data-cy="btn_mais_card"
              fab
              right
              small
              @click="abrirModal(index)"
            >
              <v-icon>
                mdi-plus
              </v-icon>
              <v-badge
                v-if="notificacaoReembolso(card)"
                avatar
                bordered
                color="red"
                data-cy="icone_notificacao_reembolso"
                offset-x="10"
                offset-y="-10"
              >
                <template v-slot:badge>
                  <v-avatar>
                    <v-icon x-small>
                      mdi-bell
                    </v-icon>
                  </v-avatar>
                </template>
              </v-badge>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <ModalFullScreen
        v-if="compraSelecionada"
        :compra-id="compraSelecionada"
        :dialog="!!compraSelecionada"
        :notificacao-mensagem="notificacaoMensagem()"
        @changeDialog="atualizarDados"
      />
      <GerenciarAssinaturas
        v-if="gerenciarAssinaturaModal"
        :compra-id="gerenciarAssinaturaModal"
        :dialog="!!gerenciarAssinaturaModal"
        @changeDialog="atualizarDados"
      />
      <NaoEncontrei
        v-if="aindaPrecisoAjudaModal"
        :dialog="!!aindaPrecisoAjudaModal"
      />
      <ModalPagamentoRecusado
        v-if="showModalPagamentoRecusado"
        v-model="showModalPagamentoRecusado"
        :motivo="motivoErro"
        :compra-id="compraIdErro"
        :permite-pix="permitePixErro"
        @pagar-pix="pagarPixDaRecusa"
      />
      <ModalPagamentoPix
        v-if="showModalPix"
        v-model="showModalPix"
        :qr-code="dadosPagamentoPix.qrCode"
        :codigo-pix="dadosPagamentoPix.codigoPix"
        :compra-id="dadosPagamentoPix.compraId"
        @dataUpdated="handlePixPaymentConfirmed"
      />
      <SnackBar
        :mensage="snackBar.message"
        :snackbar="snackBar.show"
        :color="snackBar.color"
        :timeout="snackBar.timeout"
        @changeSnackBar="value => snackBar.show = value.visible"
      />
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import api from '@/api';
import GerenciarAssinaturas from '@/components/Compras/GerenciarAssinaturas.vue';
import InfoProduto from '@/components/Compras/InfoProduto.vue';
import NaoEncontrei from '@/components/Compras/NaoEncontrei.vue';
import ModalFullScreen from '@/components/Compras/ModalFullScreen.vue';
import ModalPagamentoRecusado from '@/components/Compras/ModalPagamentoRecusado.vue';
import ModalPagamentoPix from '@/components/Compras/ModalPagamentoPix.vue';
import BtnEnviarMensagem from '@/components/Chat/BtnEnviarMensagem.vue';
import IconePagamento from '@/components/Compras/IconePagamento.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'CardDesktop',

  components: {
    GerenciarAssinaturas,
    InfoProduto,
    NaoEncontrei,
    ModalFullScreen,
    BtnEnviarMensagem,
    IconePagamento,
    ModalPagamentoRecusado,
    ModalPagamentoPix,
    SnackBar,
  },

  props: {
    dados: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataAnterior: '',
      dadosLocal: [],
      dadosDaCompra: {},
      indiceModalAberto: null,
      showModalPagamentoRecusado: false,
      motivoErro: '',
      compraIdErro: null,
      permitePixErro: false,
      showModalPix: false,
      loadingPagarReativar: {},
      dadosPagamentoPix: {
        qrCode: '',
        codigoPix: '',
        compraId: null,
      },
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
    };
  },

  computed: {
    arrayComDataModificada() {
      return this.dadosLocal.map(item => ({
        ...item,
        created_at: this.tratamentoDaData(item.created_at),
      }));
    },

    aindaPrecisoAjudaModal() {
      if (this.$route && this.$route.name === 'nao-encontrei-o-que-preciso-modal') return true;

      return null;
    },

    compraSelecionada() {
      if (this.$route && this.$route.name === 'detalhe-compra') {
        const { compraId } = this.$route.params;
        if (!compraId) return null;

        return parseInt(compraId, 10);
      }
      return null;
    },

    gerenciarAssinaturaModal() {
      if (this.$route && this.$route.name === 'gerenciar-assinatura') {
        const { compraId } = this.$route.params;
        if (!compraId) return null;

        return parseInt(compraId, 10);
      }
      return null;
    },
  },

  watch: {
    '$route.fullPath': {
      handler() {
        this.$forceUpdate();
      },
    },
    dados() {
      this.dadosLocal = this.dados;
      this.verificarRecobrancaPendente();
    },
  },

  created() {
    this.dadosLocal = this.dados;
    this.verificarRecobrancaPendente();
  },

  methods: {
    async scoreConsumidor(orderId) {
      await api.post('/consumer_score', {
        action: 'details_order',
        orderId,
      });
    },

    abrirModal(key) {
      this.indiceModalAberto = key;
      this.dadosDaCompra = this.arrayComDataModificada[key];
      this.scoreConsumidor(this.dadosDaCompra.id);
    },

    tratamentoDaData(date) {
      const data = new Date(date.replace(' ', 'T'));
      const dataAtual = `${data.getDate()}${data.getMonth()}${data.getFullYear()}`;
      const configuracoes = { year: 'numeric', month: 'long', day: 'numeric' };

      if (dataAtual !== this.dataAnterior) {
        this.dataAnterior = dataAtual;
        return data.toLocaleDateString('pt-BR', configuracoes);
      }

      return '';
    },

    notificacaoMensagem() {
      const dadosCompra = this.dados.find(({ id }) => (id === this.compraSelecionada));
      if (dadosCompra && dadosCompra.notificacao_mensagem) return dadosCompra.notificacao_mensagem;
      return false;
    },

    statusCard(card) {
      const statusReembolso = !!card.refund_request_status_slug;
      const statusCancelado = card.refund_request_status_slug === 'reembolso-cancelado';

      if (statusReembolso && !statusCancelado) return card.refund_request_status;
      if (card.membership_status_flag
        && !card.is_instalment_recovery) return card.membership_status;
      return card.status;
    },

    corStatus(card, possuiTexto = false) {
      const texto = possuiTexto ? '--text' : '';
      const flagReembolso = card.refund_request_status_flag;
      const statusReembolso = card.refund_request_status_slug === 'reembolso-cancelado';

      if (flagReembolso && !statusReembolso) return card.refund_request_status_flag + texto;
      if (card.membership_status_flag) return card.membership_status_flag + texto;

      return card.status_flag + texto;
    },

    iconeStatus(card) {
      const flagReembolso = card.refund_request_status_flag;
      const statusReembolso = card.refund_request_status_slug === 'reembolso-cancelado';

      if (flagReembolso && !statusReembolso) {
        return this.retornaIcone(card.refund_request_status_flag);
      }
      if (card.membership_status_flag) {
        return this.retornaIcone(card.membership_status_flag);
      }

      return this.retornaIcone(card.status_flag);
    },

    retornaIcone(status) {
      if (status === 'warning') return 'error';
      if (status === 'success') return 'check_circle';
      return 'cancel';
    },

    notificacaoReembolso(card) {
      const statusReembolso = [
        'aguardando-estorno',
        'aguardando-dados-consumidor',
        'aguardando-devolucao-produto',
        'aguardando-resposta-consumidor',
      ];
      const refund = card.refund_request_status_slug;
      return statusReembolso.includes(refund);
    },

    atualizarDados(dadosDialog) {
      let indice = this.indiceModalAberto;
      if (indice === null) {
        indice = this.arrayComDataModificada.findIndex(compra => compra.id === dadosDialog.data.id);
      }
      if (indice >= 0) {
        const status = dadosDialog.data.refund_request_status;
        const slug = dadosDialog.data.refund_request_status_slug;
        this.dadosLocal[indice].refund_request_status = status;
        this.dadosLocal[indice].refund_request_status_slug = slug;
      }
      this.$router.push('/minhas-compras');
    },

    valorParcelaRecuperacao(card) {
      return card.paid_recurrence_instalments > 1
        ? card.total
        : card.total - card.freight_cost;
    },

    extractErrorMessage(error) {
      const data = error.response && error.response.data;
      if (data) {
        if (data.refusalMessageMon) return data.refusalMessageMon;
        if (data.message) {
          try {
            const parsedMessage = JSON.parse(data.message);
            if (parsedMessage.error) return parsedMessage.error;
          } catch (parseError) {
            return data.message;
          }
        }
      }
      return error.message || 'Erro desconhecido';
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

    marcarComoAtiva(compraId) {
      const cardIndex = this.dadosLocal.findIndex(item => item.id === compraId);
      if (cardIndex >= 0) {
        this.$set(this.dadosLocal[cardIndex], 'membership_status', 'Ativa');
        this.$set(this.dadosLocal[cardIndex], 'membership_status_flag', 'success');
      }
    },

    abrirModalRecusa(card, error) {
      this.motivoErro = this.extractErrorMessage(error);
      this.compraIdErro = card.id;
      this.permitePixErro = card.membership_allows_pix === true;
      this.showModalPagamentoRecusado = true;
    },

    produtoIdRecobranca(card) {
      return card && card.products && card.products[0] ? card.products[0].id : null;
    },

    async gerarPixRecobranca(card) {
      const dadosProduto = this.produtoIdRecobranca(card);
      if (!dadosProduto) {
        throw new Error('Não foi possível identificar o produto da assinatura.');
      }

      const response = await api.post('/recovery-payment-pix', { dadosProduto });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao gerar pagamento PIX');
      }

      this.dadosPagamentoPix = {
        qrCode: response.data.data.qrCodePix,
        codigoPix: response.data.data.codigo,
        compraId: card.id,
      };
      this.showModalPix = true;
    },

    async recobrarCredito(card) {
      const dadosProduto = this.produtoIdRecobranca(card);
      if (!dadosProduto) {
        throw new Error('Não foi possível identificar o produto da assinatura.');
      }

      const response = await api.post('/recovery-payment-credit', { dadosProduto });

      if (!response.data.success) {
        throw new Error(response.data.message || 'Erro ao processar pagamento');
      }

      this.marcarComoAtiva(card.id);
      this.setSnackbar('Pagamento aprovado! Sua assinatura foi reativada.', 'success');
    },

    async pagarEReativar(card) {
      this.$set(this.loadingPagarReativar, card.id, true);

      try {
        if (card.is_credit_card === false) {
          await this.gerarPixRecobranca(card);
        } else {
          await this.recobrarCredito(card);
        }
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    async pagarPixDaRecusa(compraId) {
      this.showModalPagamentoRecusado = false;
      const card = this.dadosLocal.find(item => item.id === compraId);
      if (!card) return;

      this.$set(this.loadingPagarReativar, card.id, true);
      try {
        await this.gerarPixRecobranca(card);
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    async alterarFormaParaCartao(card) {
      await api.put(`/membership/payment-method/${card.id}`, {
        payment_method: 'credit_card',
      });
    },

    async recobrarComNovoCartao(card) {
      this.$set(this.loadingPagarReativar, card.id, true);
      try {
        if (card.is_credit_card === false) {
          // Assinatura em PIX/boleto: troca a forma para cartão (boleto -> 0) antes de cobrar.
          // A recobrança sozinha só reativa e quita a fatura; não altera a forma da assinatura.
          await this.alterarFormaParaCartao(card);
        }
        await this.recobrarCredito(card);
      } catch (error) {
        this.abrirModalRecusa(card, error);
      } finally {
        this.$set(this.loadingPagarReativar, card.id, false);
      }
    },

    verificarRecobrancaPendente() {
      const compraId = this.$store.state.meuperfil.assinaturaRecobrar;
      if (!compraId) return;

      const card = this.dadosLocal.find(item => item.id === compraId);
      if (!card) return;

      this.$store.dispatch('meuperfil/setAssinaturaRecobrar', null);
      this.recobrarComNovoCartao(card);
    },

    handlePixPaymentConfirmed() {
      this.marcarComoAtiva(this.dadosPagamentoPix.compraId);
      this.setSnackbar('Pagamento confirmado! Sua assinatura foi reativada.', 'success');
    },
  },
};
</script>

<style lang="scss" scoped>
.coluna-1 { width: 44%; }
.coluna-2 { width: 29%; }
.coluna-3 { width: 27%; }
.col-info-produto { width: calc(100% - 120px);}

.nome-produto {
  max-width: calc(50% - 10px);
}

.nome-plano {
  max-width: calc(50% - 10px);
}
/* eslint-enable */

</style>